import axios from 'axios';
import store from '@/store';

// TODO: GROUP REGISTER ENDPOINTS
export const getRegisteredData =
  '/echo/rest/api/v3/portal/auth/registered/data/';

export const AnnouncmentsApi = '/echo/rest/api/v3/portal/notifications'; // location id is optional, if location id is not passed, api gets it from contacts table
export const AvatarApi = '/echo/files/avatars/';
export const ActivitiesApi = '/echo/rest/api/v2/activities';

export const BannersApi = '/echo/rest/api/v3/portal/banners/portal';
export const BaseLoadApi = '/echo/rest/api/v3/portal/baseDataLoad';

export const CommApi = '/echo/rest/api/v2/comm';
export const CompanyDetailsApi = '/echo/rest/api/v2/company/details/';
export const ContactsofLocationApi = '/echo/rest/api/v3/portal/contacts/'; // must send the location_id v3/portal/contacts/location_id

export const CensusApi = '/echo/rest/api/v3/portal/stock/census';
export const CheckListsApi = '/echo/rest/api/v3/portal/checklists/'; // must send Location_id
export const CheckListDetailsApi = '/echo/rest/api/v3/portal/checklist/'; // must send report id

export const checkCensusDateApi =
  '/echo/rest/api/v3/portal/stock/censusDateCheck';

export const ConsignmentProductsApi =
  '/echo/rest/api/v3/portal/consignmentNoteProducts/'; // must send transaction_id

export const TicketThreadsApi = '/echo/rest/api/v3/portal/saveThreadMessage'; // must send ticket_id

export const EventsApi = '/echo/rest/api/v2/events?from_dateTime=';
export const EmployeesApi = '/echo/rest/api/v2/employees';
export const evaluationScoreApi =
  '/echo/rest/api/v3/portal/training/average_score';
export const evaluationDataApi =
  '/echo/rest/api/v3/portal/training/evaluations';

export const evaluationReportsApi = '/echo/rest/api/v3/portal/reports';

export const evaluationFilesApi =
  '/echo/rest/api/v3/portal/report-evaluation-files/'; // must send evaluation id

export const externalContractorsFile =
  '/echo/rest/api/v3/portal/externalContractorsFile';

export const locationExceptionsFiles =
  '/echo/rest/api/v3/portal/getLocationExceptionsFiles';

export const immediateCoverageProductsFile =
  '/echo/rest/api/v3/portal/immediateCoverageProductsFile';

export const evaluationReportSepcs =
  '/echo/rest/api/v3/portal/reports-evaluation/';

export const evaluationReportConfirmation = '/echo/rest/api/v3/portal/reports/';

export const FilesApi = '/echo/rest/api/v2/files';
export const FileUploadApi = '/echo/rest/api/v2/files/save';
export const FilesSaveApi = '/echo/rest/api/v3/portal/saveFiles';

export const SaveFilesApi = '/echo/rest/api/v3/portal/saveFiles';
export const SaveTicketFilesApi = '/echo/rest/api/v3/portal/saveTicketFiles';
export const DeleteTicketFileApi = '/echo/rest/api/v3/portal/deleteTicketFile';

export const FormUrlApi = '/echo/rest/api/v3/portal/form';
export const franchiseStoresApi = '/echo/rest/api/v3/portal/franchise/stores';
export const getAllStores = '/echo/rest/api/v3/portal/getAllStores';
export const getAllJobPositions = '/echo/rest/api/v3/portal/auth/jobs';
export const verifyMobile = '/echo/rest/api/v3/portal/auth/verify/mobile';
export const emailVerify = '/echo/rest/api/v3/portal/auth/verify/email';

export const informationMaterialApi =
  '/echo/rest/api/v3/portal/information_material';
export const InvoicesApi = '/echo/rest/api/v2/invoices';
export const InvoicePdfApi = '/echo/rest/api/v2/invoices/pdf';

export const knowledgebaseUserNotes =
  '/echo/rest/api/v3/portal/knowledgebase/notes';

export const licenseApi = '/echo/rest/api/v3/portal/license'; // must send the location_id
export const SignUpApi = '/echo/rest/api/v3/portal/auth/register';
// export const LoginApi = '/echo/rest/api/v2/auth/login';
export const LoginApi = '/echo/rest/api/v3/portal/auth/login';
export const LoginMicrosoftApi = '/echo/rest/api/v2/auth/login/microsoft';
export const LogsApi = '/echo/rest/api/v2/logs';
export const LogoutLogApi = '/echo/rest/api/v2/logs/logout';
export const noteFiles = '/echo/rest/api/v3/portal/note/files/';
export const notificationStatusApi = '/echo/rest/api/v3/portal/notification';
export const maintenanceApi = '/echo/rest/api/v3/portal/maintenance';
export const menuApi = '/echo/rest/api/v3/portal/stock/menu'; // v3/portal/stock/menu/LOCATION_ID

export const OrdersApi = '/echo/rest/api/v2/orders';

export const ProjectsApi = '/echo/rest/api/v2/projects';
export const PagesApi = '/echo/rest/api/v2/pages';
export const PostsApi = '/echo/rest/api/v3/portal/posts/'; // must pass location id
export const FAQApi = '/echo/rest/api/v3/portal/faq';
export const ProductStockApi = '/echo/rest/api/v3/portal/stock/products';
export const postFilesApi = '/echo/rest/api/v3/portal/posts/files/'; // post_id
export const postCatsApi = '/echo/rest/api/v3/portal/posts_categories';
export const postCounterApi = '/echo/rest/api/v3/portal/posts_counter';

export const widgetsTotalApi = '/echo/rest/api/v3/portal/widgets_total';

export const refreshApi = '/echo/rest/api/v2/auth/refresh-token';
export const ResetPassApi = '/echo/rest/api/v2/auth/forgot-password';
export const ForgotPassApi = '/echo/rest/api/v3/portal/auth/forgot/password';
export const ResetPasswordApi = '/echo/rest/api/v3/portal/auth/reset/password';
export const SetPassApi = '/echo/rest/api/v3/portal/auth/activate';
export const ReniewSubApi = '/echo/rest/api/v2/subs/updateSubscription';
export const ReceiptsApi = '/echo/rest/api/v3/portal/softone/receipts';

export const SharepointApi = '/echo/rest/api/v3/portal/sharepoint'; // must pass file_id as url parameter  /sharepoint/FILE_ID
export const SubsApi = '/echo/rest/api/v2/subs';
export const StaffApi = '/echo/rest/api/v3/portal/staff';
export const setTaskCompleted = '/echo/rest/api/v3/portal/task_completed/'; // needs task_id parameter

export const sharepoinFileSearchApi =
  '/echo/rest/api/v3/portal/sharepointFileSearch';
export const sharepoinFileApi = '/echo/rest/api/v3/portal/sharepointFileGet';

export const TasksApi = '/echo/rest/api/v3/portal/tasks'; // needs location_id parameter
export const TaskArchive = '/echo/rest/api/v3/portal/task/'; // needs task_id parameter

export const TicketsApi = '/echo/rest/api/v3/portal/tickets'; // [/{location_id}[/{status}]] parameters
export const TicketInfoApi = '/echo/rest/api/v3/portal/ticket';
export const ThreadsApi = '/echo/rest/api/v2/tickets/thread';
export const ThreadEditApi = '/echo/rest/api/v2/tickets/thread/update'; // Thread content edit (update)
export const TicketTypeApi = '/echo/rest/api/v2/tickets/type';
export const TicketsElementsDataApi =
  '/echo/rest/api/v3/portal/ticketsElementsData';
export const saveTicket = '/echo/rest/api/v3/portal/saveTicket';
export const sendTicketEmailsAfterSave =
  '/echo/rest/api/v3/portal/sendTicketEmailsAfterSave';

// export const TranslationsApi = '/echo/rest/api/v2/translations?account_id=1';
export const TranslationsApi =
  '/echo/rest/api/v3/portal/translations?app_id=9000';
export const TransactionsApi = '/echo/rest/api/v2/transactions';
export const TraineeTraining = '/echo/rest/api/v3/portal/training/trainee';
export const TraineeTrainingArchive =
  '/echo/rest/api/v3/portal/training/trainee/archive';
export const TraineeTrainingMaterial =
  '/echo/rest/api/v3/portal/training/material';
export const TrainingNotes = '/echo/rest/api/v3/portal/training/notes';
export const TrainingVideos = '/echo/rest/api/v3/portal/training/videos';
export const TrainingNotesFiles = '/echo/rest/api/v3/portal/training/files';

export const UserApi = '/echo/rest/api/v3/portal/me';
export const UsersApi = '/echo/rest/api/v3/portal/users';
export const UpdateReadStatus =
  '/echo/rest/api/v3/portal/knowledgebase/readStatus';
export const UpdateUser = '/echo/rest/api/v3/customer';
export const UpdateUserExtraDetails =
  '/echo/rest/api/v3/portal/updateUserExtraDetails';

export const DisableAccessApi = '/echo/rest/api/v3/portal/disableUserAccess';

export const WegApi = '/echo/rest/api/v3/portal/weg';
export const wegUserAuth = '/echo/rest/api/v3/portal/wegPortalAuth';

export const getHeader = function() {
  if (localStorage.getItem('authUser')) {
    let selectedLanguage = store.state.app.language
      ? store.state.app.language
      : 'en';
    if (selectedLanguage === 'gr') {
      selectedLanguage = 'el';
    }
    const tokenData = JSON.parse(atob(localStorage.getItem('authUser')));
    return {
      Accept: 'application/json',
      Authorization: 'Bearer ' + tokenData.access_token,
      Language: selectedLanguage
    };
  } else {
    return {
      Accept: 'application/json'
    };
  }
};

export const getHeaderRefresh = function() {
  // const tokenData = JSON.parse(atob(localStorage.getItem('authUser')))
  const tokenData = store.state.data.tokenData;
  // const tokenData = store.getters.isAuthenticated
  const headers = {
    Accept: 'application/json',
    Authorization: 'Bearer ' + tokenData.refresh_token
  };
  return headers;
};

export const refreshToken = function() {
  var refToken = JSON.parse(atob(localStorage.getItem('authUser')));
  refToken = refToken.refresh_token;
  return new Promise((resolve, reject) => {
    axios
      .post('https://' + store.state.data.hostname + refreshApi, null, {
        headers: getHeaderRefresh()
      })
      .then(function(response) {
        // handle success
        // console.log(response)
        const authUser = {};
        authUser.access_token = response.data.access_token;
        authUser.refresh_token = refToken;
        // localStorage.setItem('authUser', JSON.stringify(authUser))
        localStorage.setItem('authUser', btoa(JSON.stringify(authUser)));
        store.state.data.tokenData = authUser;
        resolve();
        // window.location.reload()
      })
      .catch(function(error) {
        // handle error
        // console.log(error)
        if (error.response.status === 401) {
          localStorage.removeItem('authUser');
          localStorage.removeItem('authBUser');
          store.state.data.tokenData = '';
          window.location.href = '/';
        }
        reject(error);
      });
  });
};



// WEBPACK FOOTER //
// ./src/utils/echoApi.js